import styled from "styled-components";

export const Container = styled.div`
padding: 20px;
  background: linear-gradient(135deg, #f5f9fc 0%, #ffffff 100%);
  min-height: 100vh;
  @media screen and (max-width: 568px) {
    .header {
      flex-direction: column;
      gap: 20px;
      h3 {
        font-size: 15px;
        color: #1a237e;
      }
    }
  }
  .header {
    display: flex;
    justify-content: space-between;
    .texts {
      h3 {
        background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
        font-size: 32px;
        line-height: 44px;
        color: #1a237e;
      }
      p {
        margin-top: 5px;
        line-height: 22px;
        font-size: 16px;
        color: #667085;
      }
    }

    .link-buttons {
      display: flex;
      gap: 10px;
      .see-more,
      .add-campaign {
        padding: 10px 16px;
        height: 40px;
        border: 1px solid #d0d5dd;
        border-radius: 8px;
        font-size: 14px;
        background-color: transparent;
        text-decoration: none;
        cursor: pointer;
        color: #344054;
      }
      .add-campaign {
        color: #fff;
        border: 1px solid #03a9f4;
        background-color: #03a9f4;
      }
    }
  }
`;

export const CardWrapper = styled.div`
  margin-top: 30px;
  width: 100%;
  display: grid;
  gap: 20px;
  margin-bottom: 30px;
  //margin: auto;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: 976px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const ChartWrapper = styled.div`
  margin-top: 30px;
  gap: 24px;
  background: #ffffff;
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(3, 169, 244, 0.08);
  border: 1px solid #e3f2fd;
`

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  @media screen and (max-width: 668px) {
    flex-direction: column;
  }
`;
export const TableWrapper = styled.div`
  background: #ffffff;
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(3, 169, 244, 0.08);
  border: 1px solid #e3f2fd;
  margin-top: 30px;
  @media screen and (max-width: 568px) {
    .header {
      flex-direction: column;
      gap: 20px;
      h4 {
        font-size: 15px;
        color: #1a237e;
      }
    }
  }
  .header {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    h4 {
      background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
      font-size: 20px;
      color: #1a237e;
    }
    p {
      margin-top: 5px;
      font-size: 14px;
      color: #989fad;
      //margin-bottom: -60px;
    }

    .link-buttons {
      display: flex;
      gap: 10px;
      .see-more,
      .add-campaign {
        padding: 10px 16px;
        height: 40px;
        border: 1px solid #d0d5dd;
        border-radius: 8px;
        font-size: 14px;
        background-color: transparent;
        text-decoration: none;
        cursor: pointer;
        color: #344054;
      }
      .add-campaign {
        color: #fff;
        border: 1px solid #03a9f4;
        background-color: #03a9f4;
      }
    }
  }
`;
